import { IUser } from '@/utils/types/User';
import { IJackpotPlayer } from '@/utils/types/IJackpotPlayer';
import HistoryAvatar from '@/components/Jackpot/History/HistoryAvatar';
import InfoSpan from '@/components/InfoSpan/InfoSpan';

interface Props {
    user: IUser;
    id: number;
    secret: string;
    hash: string;
}

const FairplayModal = ({ user, id, secret, hash }: Props) => {
    return (
        <div className={'flex flex-col items-center'}>
            <div className={'relative'}>
                <HistoryAvatar
                    spanClassName={'left-[-12px] absolute top-[-14px]'}
                    winner
                    user={user as IJackpotPlayer}
                />
            </div>
            <p className={'text-yellow mb-6 mt-3 font-semibold text-lg'}>{user.name}</p>

            <div className={'flex gap-2 max-xl:flex-wrap max-xl:justify-center max-xl:text-sm'}>
                <InfoSpan left={'Round ID:'} right={id} />
                <InfoSpan className={''} left={'Hash:'} right={hash} />
                <InfoSpan left={'Secret:'} right={secret} />
            </div>
        </div>
    );
};

export default FairplayModal;
